import {Component, createRef} from 'react';
import PropTypes from 'prop-types';
import Button from 'ui/Button';
import Flyout from 'ui/Flyout';
import Icon from 'ui/Icon';
import {ContentStatus} from '@livongo/protobuf-grpc-external-education';
import {withTranslation} from 'react-i18next';
import TableOfContents from './TableOfContents';
import ButtonReturn from './ButtonReturn';

class Navigation extends Component {
    static propTypes = {
        isOneApp: PropTypes.bool,
        children: PropTypes.element,
        hasStarted: PropTypes.bool,
        hasFinished: PropTypes.bool,
        isNextDisabled: PropTypes.bool,
        currentLesson: PropTypes.object.isRequired,
        currentPage: PropTypes.object,
        highestPageViewed: PropTypes.number.isRequired,
        onBackClick: PropTypes.func.isRequired,
        onNextClick: PropTypes.func.isRequired,
        onExitClick: PropTypes.func.isRequired,
        onTOCPageSelected: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };
    state = {
        showTOC: false,
    };
    _flyout = createRef();

    constructor(props) {
        super(props);

        const {currentLesson} = props;

        this._lessonTitle = currentLesson
            .getTextFieldsMap()
            .get('SUBTITLE')
            .getTextValue();
        this._tocPages = currentLesson.getPagesList().filter(page => {
            return page.showInTOC === true;
        });
    }

    _onTOCToggle = () => {
        this.setState((prevState, props) => {
            return {
                showTOC: !prevState.showTOC,
            };
        });
    };

    _onTOCPageSelected = pageNumber => {
        this.props.onTOCPageSelected(pageNumber);

        this._flyout.current.hide();
    };

    _onExitClick = () => {
        this.props.onExitClick();
    };

    _renderTOCButton() {
        return (
            <Button
                className="Navigation-button Navigation-toc"
                aria-label={this.props.t('toc')}
                onClick={this._onTOCToggle}
            >
                <Icon name="toc" size={24} />
            </Button>
        );
    }

    render() {
        const {
            t,
            isOneApp,
            children,
            hasStarted,
            hasFinished,
            isNextDisabled,
            currentLesson,
            currentPage,
            highestPageViewed,
            onBackClick,
            onNextClick,
        } = this.props;
        const {showTOC} = this.state;

        return (
            <div className="Navigation">
                <div className="Navigation-header">
                    {hasStarted ? (
                        <>
                            {this._renderTOCButton()}
                            <p>{this._lessonTitle}</p>
                            <Button
                                className="Navigation-button Navigation-close"
                                aria-label={t('close')}
                                onClick={this._onExitClick}
                            >
                                <Icon name="times" size={24} />
                            </Button>
                        </>
                    ) : (
                        <>
                            {!hasFinished && (
                                <ButtonReturn isOneApp={isOneApp} hasIcon />
                            )}
                            <p>{t('lessons')}</p>
                        </>
                    )}
                </div>
                {/* children represents the App-content */}
                {children}
                {hasStarted && !hasFinished && (
                    <div className="Navigation-footer">
                        {this._renderTOCButton()}
                        <div className="Navigation-arrows">
                            {currentPage.getPageNumber() > 1 && (
                                <Button
                                    className="Navigation-button Navigation-back"
                                    aria-label={t('back')}
                                    onClick={onBackClick}
                                >
                                    <Icon name="arrow-left" size={24} />
                                    <span>{t('back')}</span>
                                </Button>
                            )}
                            <Button
                                className="Navigation-button Navigation-next"
                                aria-label={t('next')}
                                disabled={isNextDisabled}
                                onClick={onNextClick}
                            >
                                <Icon name="arrow-right" size={24} />
                                <span>{t('next')}</span>
                            </Button>
                        </div>
                    </div>
                )}
                {showTOC && (
                    <Flyout
                        ref={this._flyout}
                        title={t('inThisLesson')}
                        onHidden={this._onTOCToggle}
                    >
                        <TableOfContents
                            currentPage={currentPage}
                            pages={this._tocPages}
                            highestPageViewed={highestPageViewed}
                            isLessonComplete={
                                currentLesson
                                    .getLessonUserData()
                                    .getStatus() ===
                                ContentStatus.Values.COMPLETED
                            }
                            onPageSelected={this._onTOCPageSelected}
                        />
                    </Flyout>
                )}
            </div>
        );
    }
}

export default withTranslation()(Navigation);
